import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/config/business";

const Faq = () => (
  <section id="faq" className="scroll-mt-24 py-16 sm:py-24">
    <div className="mx-auto max-w-3xl px-4 sm:px-8">
      <div className="text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#9E7B36]">
          Good to Know
        </p>
        <h2 className="mt-3 font-serif text-3xl font-medium tracking-tight text-[#1C1917] sm:text-4xl">
          Frequently Asked Questions
        </h2>
      </div>
      <Accordion
        type="single"
        collapsible
        data-testid="faq-accordion-container"
        className="mt-10 space-y-3"
      >
        {FAQS.map((faq, index) => (
          <AccordionItem
            key={faq.q}
            value={`faq-${index}`}
            className="rounded-xl border border-[#E7E2DA] bg-white px-5 shadow-[0_4px_20px_-2px_rgba(44,39,32,0.05)]"
          >
            <AccordionTrigger
              data-testid={`faq-trigger-${index}`}
              className="py-5 text-left text-sm font-semibold text-[#1C1917] hover:no-underline sm:text-base"
            >
              {faq.q}
            </AccordionTrigger>
            <AccordionContent
              data-testid={`faq-content-${index}`}
              className="text-sm leading-relaxed text-[#57534E]"
            >
              {faq.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default Faq;
